var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_9545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90216 3.35742H3.54501C2.91355 3.35742 2.30794 3.60827 1.86143 4.05479C1.41491 4.5013 1.16406 5.10691 1.16406 5.73837V16.4527C1.16406 17.0841 1.41491 17.6897 1.86143 18.1362C2.30794 18.5828 2.91355 18.8336 3.54501 18.8336H15.4498C16.0812 18.8336 16.6868 18.5828 17.1334 18.1362C17.5799 17.6897 17.8307 17.0841 17.8307 16.4527V11.0955",
    stroke: "#C31A7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4496 4.54875L16.5841 5.73923M17.8305 2.12852C18.1479 2.45668 18.3236 2.89639 18.3198 3.3529C18.3161 3.8094 18.1331 4.24614 17.8103 4.56899L9.49721 12.8821L5.92578 14.0726L7.11626 10.5011L15.4341 2.11304C15.7265 1.81837 16.1178 1.64261 16.5323 1.61974C16.9468 1.59687 17.3551 1.72852 17.6782 1.98923L17.8305 2.12852Z",
    stroke: "#C31A7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_9545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePost);
export default __webpack_public_path__ + "static/media/createPost.c224cddece461c318e969a1204a42db8.svg";
export { ForwardRef as ReactComponent };